import { defineCommands, type CommandsOf, applyEntityDataChanges } from '../../commands/defineCommands';
import type { CanvasStoreContext } from '../../types';
import type { AdrTriggerData } from '../../entityTypes';

export const adrTriggerCommands = defineCommands({
  'adr-trigger.updateData': (ctx: CanvasStoreContext, event: {
    entityId: string; dataChanges: Partial<AdrTriggerData>;
  }): CanvasStoreContext => applyEntityDataChanges(ctx, event.entityId, event.dataChanges),
});

export type AdrTriggerCommand = CommandsOf<typeof adrTriggerCommands>;
